import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import ServiceBooking from "./pages/service-booking";
import ClientManagement from "./pages/client-management";
import About from "./pages/about/about";
import Layout from "./layout";
import Contact from "./pages/contact/contact";
import ServicePage from "./pages/ServicePage/ServicePage";
import Home from "./pages/service-booking/home/home";
import Login from './pages/Login';
import AdminRoute from './AdminRoute';
import Aimode from './pages/AiMode/Aimode';
import Photolab from './pages/PhotoLab/Photolab';


const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Wrap routes that need header/footer with Layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/service" element={<ServicePage />} />

            {/* ✅ Protected Admin Routes */}
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <ClientManagement />
                </AdminRoute>
              }
            />

            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/service-booking" element={<ServiceBooking />} />
            <Route path="/AiMode" element={<Aimode />} />
            <Route path="/Photolab" element={<Photolab />} />
          </Route>

          {/* 🔑 Login Route (no header/footer) */}
          <Route path="/login" element={<Login />} />

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
